import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';
import { useStore } from 'src/hooks';
import { PROMO, PROMO_TYPE } from 'src/common/constants';
import * as styles from 'src/components/sidebar/promo/styles.less';

export const calculateTimeLeft = (endTime: number, currentTime: number): string => {
    const promoTimeDifference: number = (endTime - currentTime) * 1000;

    if (promoTimeDifference <= 0 || currentTime < 0) {
        throw new Error('Current time has already passed end time.');
    }

    return returnFormattedTime(promoTimeDifference);
};

const returnFormattedTime = (promoTimeDifference: number): string => {
    const days: number = Math.floor(promoTimeDifference / (1000 * 60 * 60 * 24));
    const hours: number = Math.floor((promoTimeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes: number = Math.floor((promoTimeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds: number = Math.floor((promoTimeDifference % (1000 * 60)) / 1000);

    const daysLeft = `${days} ${days === 1 ? 'day' : 'days'}`;
    const hoursLeft = `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
    const minutesLeft = `${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
    const secondsLeft = `${seconds} sec`;

    if (days > 0) {
        return `${daysLeft} ${hoursLeft}`;
    }

    if (hours <= 0) {
        return `${minutesLeft} ${secondsLeft}`;
    }

    return `${hoursLeft} ${minutesLeft}`;
};

export const updatePromoCountdown = (countdown: HTMLDivElement): void => {
    const promoEndTime: number | null = Number(countdown.getAttribute('data-date-end'));
    const TIMER_UPDATE_DELAY = 1000;

    displayPromoCountdown(countdown, promoEndTime);

    setInterval(() => {
        displayPromoCountdown(countdown, promoEndTime);
    }, TIMER_UPDATE_DELAY);
};

const displayPromoCountdown = (countdown: HTMLDivElement, promoEndTime: number): void => {
    if (countdown && promoEndTime) {
        const promoCurrentTime: number = Math.floor(Date.now() / 1000);

        if (isNaN(promoEndTime) || isNaN(promoCurrentTime)) {
            throw new Error('No valid UNIX timestamp value provided.');
        }

        try {
            const countdownValue = calculateTimeLeft(promoEndTime, promoCurrentTime);
            countdown.setAttribute('data-date-left', countdownValue);
        } catch {
            countdown.classList.remove(styles.promo_logo__countdown);
        }
    }
};

interface PromoCountdownProps {
    isFrame?: boolean;
}

const PromoCountdown = ({ isFrame }: PromoCountdownProps) => {
    const ctx = useStore();
    const countdown = useRef<HTMLDivElement>(null);
    const promoType = ctx.promo.type.value;
    const isLoggedIn = ctx.user.isLoggedIn.value;

    useEffect(() => {
        if (countdown.current) {
            updatePromoCountdown(countdown.current);
        }
    });

    if (promoType) {
        if (isLoggedIn && promoType === PROMO_TYPE.SPOTPRIZES) {
            return (
                <a href={PROMO[promoType].route} data-native={isFrame ? true : null} target={isFrame ? '_top' : undefined}>
                    <div class={`${styles.promo_logo} ${styles.promo_logo__countdown} ${styles[PROMO[promoType].layoutClass]}`} data-date-end={ctx.promo.countdownEnd} ref={countdown}>
                        <b>CamContacts</b>
                        <div class={styles.promo_logo__inner} />
                    </div>
                </a>
            );
        }

        return (
            <div class={`${styles.promo_logo} ${styles.promo_logo__countdown} ${styles[PROMO[promoType].layoutClass]}`} data-date-end={ctx.promo.countdownEnd} ref={countdown}>
                <b>CamContacts</b>
                <div class={styles.promo_logo__inner} />
            </div>
        );
    }

    return null;
};

export default PromoCountdown;
